export interface PracticeArea {
  title: string;
  slug: string;
  shortDescription: string;
  backgroundImage: string;
}

export const practiceAreas: PracticeArea[] = [
  {
    title: 'Business Law',
    slug: 'business-law',
    shortDescription: 'Corporate, commercial, and international business legal services.',
    backgroundImage: 'https://janssen-law.s3.us-east-2.amazonaws.com/business-law.jpg',
  },
  {
    title: 'Real Estate Law',
    slug: 'real-estate',
    shortDescription: 'Residential and commercial real estate transactions and disputes.',
    backgroundImage: 'https://janssen-law.s3.us-east-2.amazonaws.com/real-estate-law.png',
  },
  {
    title: 'Immigration Law',
    slug: 'immigration',
    shortDescription: 'Business immigration, work permits, and pre-immigration planning.',
    backgroundImage: 'https://janssen-law.s3.us-east-2.amazonaws.com/immigration-law.png',
  },
  {
    title: 'Wills & Estates',
    slug: 'wills-estates',
    shortDescription: 'Estate planning, trusts, powers of attorney, and elder law.',
    backgroundImage: 'https://janssen-law.s3.us-east-2.amazonaws.com/wills-estate-law.jpg',
  },
];
